import { BoelsBaseSite } from './boels-base-site.model';
import {
  BoelsAddress,
  BoelsOpeningSchedule,
  PointOfService,
  Specialism,
} from './boels-point-of-service.model';
import { ProductSearchPage } from './product-search.model';
import {
  BaseOption,
  BOProduct,
  Classification,
  Feature,
  FeatureValue,
  Price,
  ProductReference,
  VariantOption,
} from './product.model';
import { Image } from './image.model';
import { GeoPoint, PaginationModel, SortModel } from './misc.model';

export interface PlpPrice {
  price: string;
  label: string;
}

export interface BoelsVariantOption extends VariantOption {
  oneCall?: boolean;
}

export interface BoelsBaseOption extends BaseOption {
  options?: BoelsVariantOption[];
}

export interface BimFile {
  extension: string;
  mimeType: string;
  url: string;
}

export interface BimDocument {
  bimFiles: BimFile[];
  brand: string;
  brandType: string;
  thumbnail: string;
}

export interface UnitPrice extends Price {
  unit?: string;
  unitName?: string;
  netPrice?: boolean;
  unitQuantity?: number;
  sdFormattedValue?: string;
}

export interface BOProductSearchPage extends ProductSearchPage {
  boelsBreadcrumbs?: any[];
}

export enum PriceTypeEnum {
  PIECES = 'PIECES',
  DAY = 'DAY-RENT',
  DAYPLUS = '5DAYPLUS-RENT',
  WEEK = 'WEEK-RENT',
  MONTH = 'MONTH-RENT',
  WEAR = 'WEAR-MINIMUM',
  WEARUNIT = 'WEAR-PER-0.1MM',
}

export interface BOClassification extends Classification {
  features?: BOFeature[];
}

export interface BOFeatureValue extends FeatureValue {
  code?: string;
}

export interface BOFeature extends Feature {
  featureValues?: BOFeatureValue[];
}

export interface BulletPoints {
  code?: string;
  text?: string;
}

export interface BoelsProductReference extends ProductReference {
  target?: BOProduct;
}

export enum BoelsProductReferenceType {
  MANDATORY_SALE = 'MANDATORY_SALE_ACCESSORY',
  MANDATORY_HIRE = 'MANDATORY_HIRE_ACCESSORY',
  OPTIONAL_SALE = 'OPTIONAL_SALE_ACCESSORY',
  OPTIONAL_HIRE = 'OPTIONAL_HIRE_ACCESSORY',
}

export interface BoelsProductTax {
  formattedValue?: string;
}

export interface StoreFinderSearchPage {
  boundEastLongitude?: number;
  boundNorthLatitude?: number;
  boundSouthLatitude?: number;
  boundWestLongitude?: number;
  locationText?: string;
  pagination?: PaginationModel;
  product?: BOProduct;
  sorts?: SortModel[];
  sourceLatitude: number;
  sourceLongitude: number;
  stores?: BoelsPointOfService[];
}

export interface BoelsPointOfService extends PointOfService {
  address?: BoelsAddress;
  baseSites?: BoelsBaseSite[];
  description?: string;
  displayName?: string;
  displayNameSlug?: string;
  distanceKm?: number;
  features?: {
    [propertyName: string]: string;
  };
  formattedAddress: string;
  formattedDistance?: string;
  geoPoint: GeoPoint;
  hasRentalWall?: boolean;
  isCramoPOS?: boolean;
  mapIcon?: Image;
  metaDescription?: string;
  metaTitle?: string;
  name?: string;
  openingHours?: BoelsOpeningSchedule;
  seoStoreContent?: string;
  specialisms?: Array<Specialism>;
  storeContent?: string;
  storeImages?: Image[];
  url?: string;
}

export interface SearchConfig {
  pageSize?: number;
  currentPage?: number;
  sort?: string;
}
